import BaseModule from "~/vuex/modules/base-module";

let enquiryBrochureEnquiries = {...BaseModule};

enquiryBrochureEnquiries.state = function () {
    let state = BaseModule.state();

    state.lastDate = null;
    state.sort = {};

    return state;
};

export default enquiryBrochureEnquiries;
